import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import axios from "axios";

import { isSiteInMaintenanceStatus } from "./config/config";
import Navbar from "./components/on-all-pages/Navbar";
import Footer from "./components/on-all-pages/Footer";
import NotFound from "./components/utils/NotFound";
import SiteInMaintenance from "./pages/SiteInMaintenance";

import Home from "./pages/Home";
import Auth from "./pages/Auth";
import ResetPassword from "./pages/ResetPassword";
import Doubt from "./pages/Doubt";
import Profile from "./pages/Profile";

import { AuthProvider } from "./context/AuthContext";
import { siteStatus } from "./functions/server-requests/utils";

import Loading from "./components/utils/Loading";

import "./App.css";

axios.defaults.withCredentials = true;

const App = () => {
  const [isSiteInMaintenance, setIsSiteInMaintenance] =
    useState(isSiteInMaintenanceStatus === "true" ? null : false);
  const [expectedCompletionDateOfMaintenance, setExpectedCompletionDateOfMaintenance] = useState("");
  const [dateSup, setDateSup] = useState("");

  useEffect(() => {
    const getSiteStatus = async () => {
      const getSiteStatusRes = await siteStatus();

      if (getSiteStatusRes.status === 200) {
        const data = getSiteStatusRes.data.siteStatus[0];

        setIsSiteInMaintenance(data.isSiteInMaintenance); // true or false
        setExpectedCompletionDateOfMaintenance(data.expectedCompletionDateOfMaintenance); // 01 January 2023
        setDateSup(data.dateSup); // st
      }
      else {
        // if status didn't received
        setIsSiteInMaintenance(true);
      }
    }

    if (isSiteInMaintenance === null) {
      getSiteStatus();
    }
  }, []);

  if (isSiteInMaintenance === null) {
    return <Loading />;
  }
  else {
    return (
      <AuthProvider>
        <Router>
          <Navbar isSiteInMaintenance={isSiteInMaintenance} />

          {
            !isSiteInMaintenance
              ? <Routes>
                <Route path="/" element={<Home />} />

                <Route path="/auth/:authType" element={<Auth />} />

                <Route path="/reset-password/:token" element={<ResetPassword />} />

                <Route path="/doubt/:doubtId" element={<Doubt />} />

                <Route path="/profile/:userId" element={<Profile />} />

                <Route path="*" element={<NotFound />} />
              </Routes>
              : <Routes>
                <Route
                  path="*"
                  element={
                    <SiteInMaintenance
                      expectedCompletionDateOfMaintenance={expectedCompletionDateOfMaintenance}
                      dateSup={dateSup}
                    />
                  }
                />
              </Routes>
          }

          <Footer />
        </Router>
      </AuthProvider>
    );
  }
}

export default App;